import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, WritableSignal, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IAcquedotto } from '../acquedotti.model';
import { AcquedottiService } from '../acquedotti.service';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { KeyValueFormComponent } from 'src/app/shared/components/forms/key-value-form/key-value-form.component';

@Component({
  selector: 'app-dettaglio-page',
  standalone: true,
  imports: [
    CommonModule,
    PageDetailComponent,
    EditableCardComponent,
    TextFieldComponent,
    KeyValueFormComponent
  ],
  templateUrl: './dettaglio-page.component.html',
  styleUrl: './dettaglio-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DettaglioPageComponent {
  @Input() id = '0';

  form: FormGroup;
  model: WritableSignal<IAcquedotto | undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private readonly fb: FormBuilder,
    public readonly service: AcquedottiService,
  ) {
    this.form = this.fb.group({});
  }
}
